module.exports = __webpack_public_path__ + "static/media/bd-urmc-case-study-big-data-results.e1e6cbd8.pdf";